import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useAbout, useAboutAvatar } from '../hooks/useAbout';

export default function About() {
  const data = useAbout();
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  const avatarUrl = useAboutAvatar();
  const bio = data?.bio || '';
  const interests = Array.isArray(data?.interests) ? data.interests : [];
  const available = data?.available_for_work === true;

  return (
    <section id="about" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">about</p>
          <h2 className="section-title">Human Side</h2>
          <div className="section-line" />
        </header>

        <div className="about-grid">
          <div className="about-image-col">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt={data?.name || 'Rupesh Bhatta'}
                className="about-avatar"
              />
            ) : (
              <div className="about-avatar-placeholder" aria-hidden="true">RB</div>
            )}
            {available && (
              <div className="available-badge">
                <span className="dot" />
                Available for work
              </div>
            )}
          </div>

          <div className="about-text-col">
            {bio ? (
              <div className="about-bio">
                {bio.split('\n\n').filter(Boolean).map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            ) : (
              <div className="about-bio">
                <p>
                  I'm a Software Engineer based in Nepal, passionate about building intelligent
                  systems, full-stack applications, and automation tools that solve real problems.
                </p>
                <p>
                  I enjoy bridging the gap between research and production — turning complex ideas
                  into clean, maintainable code.
                </p>
              </div>
            )}

            {interests.length > 0 && (
              <div>
                <p className="interests-title">Outside of Code</p>
                <div className="interest-grid">
                  {interests.map((item, i) => (
                    <span key={i} className="interest-tag">{item}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
